import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

interface HreflangLink {
  lang: string;
  url: string;
}

interface PageTitleProps {
  title: string;
  description?: string;
  canonicalUrl?: string;
  hreflang?: HreflangLink[];
  language?: string;
}

export const PageTitle: React.FC<PageTitleProps> = ({ 
  title, 
  description, 
  canonicalUrl,
  hreflang = [],
  language = 'en'
}) => {
  const location = useLocation();
  
  // Generate canonical URL
  const getCanonicalUrl = () => {
    if (canonicalUrl) {
      return canonicalUrl;
    }
    
    // Get the current URL
    const currentUrl = window.location.origin + location.pathname;
    
    // Remove trailing slash for consistency (except for root)
    return location.pathname === '/' ? currentUrl : currentUrl.replace(/\/$/, '');
  };

  // Default hreflang for English (US)
  const defaultHreflang: HreflangLink[] = [
    {
      lang: 'en',
      url: getCanonicalUrl()
    },
    {
      lang: 'en-US',
      url: getCanonicalUrl()
    },
    {
      lang: 'x-default',
      url: getCanonicalUrl()
    }
  ];

  // Combine default hreflang with custom ones
  const allHreflang = [...defaultHreflang, ...hreflang];

  return (
    <Helmet>
      <html lang={language} />
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={getCanonicalUrl()} />
      
      {/* Hreflang tags */}
      {allHreflang.map((link, index) => (
        <link 
          key={`${link.lang}-${index}`}
          rel="alternate" 
          hrefLang={link.lang} 
          href={link.url} 
        />
      ))}
    </Helmet>
  );
}; 